import { render, staticRenderFns } from "./RecurringViberCampaignsListRoute.vue?vue&type=template&id=600c690a&scoped=true&"
import script from "./RecurringViberCampaignsListRoute.vue?vue&type=script&lang=js&"
export * from "./RecurringViberCampaignsListRoute.vue?vue&type=script&lang=js&"
import style0 from "./RecurringViberCampaignsListRoute.vue?vue&type=style&index=0&id=600c690a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600c690a",
  null
  
)

export default component.exports